import { render, staticRenderFns } from "./promotion-add.vue?vue&type=template&id=b5a4345a&"
import script from "./promotion-add.vue?vue&type=script&lang=js&"
export * from "./promotion-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports